// Dashboard new added pharmacy list
export const dashboardPharmacyList = [
  {
    name: 'Ad',
    id: 'name',
    selector: row => row['name'],
    sortable: false,
    grow: 2
  },
  {
    name: 'İl',
    id: 'city',
    selector: row => row['city'],
    sortable: false,
    maxWidth: '165px'
  },
  {
    name: 'İlçe',
    id: 'district',
    selector: row => row['district'],
    sortable: false
  },
  {
    name: 'Mahalle',
    id: 'region',
    selector: row => row['region'],
    sortable: false
  },
  {
    name: 'Turp Eczanesi',
    id: 'is_turp_pharmacy',
    selector: row => row['is_turp_pharmacy'],
    sortable: false,
    center: true
  }
];

// System Users List
export const systemUsersList = [
  {
    name: 'Ad',
    id: 'name',
    selector: row => row['name'],
    sortable: true
  },
  {
    name: 'Soyad',
    id: 'surname',
    selector: row => row['surname'],
    sortable: false
  },
  {
    name: 'E-Posta',
    id: 'email',
    selector: row => row['email'],
    sortable: false,
    grow: 2
  },
  {
    name: 'Görev Bilgisi',
    id: 'title',
    selector: row => row['title'],
    sortable: false,
    maxWidth: '220px'
  }
];

// Pharmacy List
export const pharmaciesList = [
  {
    name: 'Eczane Adı',
    id: 'name',
    selector: row => row['name'],
    sortable: true,
    minWidth: '250px',
    grow: 3
  },
  {
    name: 'İl',
    id: 'city',
    selector: row => row['city'],
    sortable: false,
    minWidth: '175px',
    maxWidth: '190px'
  },
  {
    name: 'İlçe',
    id: 'district',
    selector: row => row['district'],
    sortable: false,
    minWidth: '175px',
    maxWidth: '185px'
  },
  {
    name: 'Semt/Mahalle',
    id: 'region',
    selector: row => row['region'],
    sortable: false,
    minWidth: '195px',
    grow: 2
  },
  {
    name: 'Nöbet Bilgisi',
    id: 'on_duty',
    selector: row => row['on_duty'],
    sortable: false,
    minWidth: '150px'
  }
];

// Pharmacy Users List
export const pharmacyUsersList = [
  {
    name: 'Ad Soyad',
    id: 'full_name',
    selector: row => row['full_name'],
    sortable: true
  },
  {
    name: 'E-Posta',
    id: 'email',
    selector: row => row['email'],
    sortable: false,
    grow: 2
  },
  {
    name: 'Telefon',
    id: 'telephone',
    selector: row => row['telephone'],
    sortable: false
  },
  {
    name: 'Durum',
    id: 'status',
    selector: row => row['status'],
    sortable: false,
    center: true,
    minWidth: '120px',
    maxWidth: '160px'
  }
];

export const supportFormList = [
  {
    name: 'Eczane Adı',
    id: 'pharmacy_name',
    selector: row => row['pharmacy_name'],
    sortable: true,
    grow: 2,
    minWidth: '200px'
  },
  {
    name: 'Konu',
    id: 'subject',
    selector: row => row['subject'],
    sortable: false,
    minWidth: '200px'
  },
  {
    name: 'Tarih - Saat',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    maxWidth: '160px'
  },
  {
    name: 'Detay',
    id: 'detail_btn',
    selector: row => row['detail_btn'],
    sortable: false,
    center: true,
    ignoreRowClick: true
  }
];

// End Users - Customer List
export const customerList = [
  {
    name: 'Ad',
    id: 'name',
    selector: row => row['name'],
    sortable: true
  },
  {
    name: 'Soyad',
    id: 'surname',
    selector: row => row['surname'],
    sortable: true
  },
  {
    name: 'Telefon',
    id: 'telephone',
    selector: row => row['telephone'],
    sortable: false
  },
  {
    name: 'E-Posta',
    id: 'email',
    selector: row => row['email'],
    sortable: false,
    grow: 3
  }
];

// Customer Agreements
export const customerAgreementsList = [
  {
    name: 'Versiyon No',
    id: 'version_number',
    selector: row => row['version_number'],
    sortable: false,
    maxWidth: '110px'
  },
  {
    name: 'Oluşturulma Tarihi',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    maxWidth: '165px'
  },
  {
    name: 'Onaylama Tarihi',
    id: 'consent_date',
    selector: row => row['consent_date'],
    sortable: false,
    maxWidth: '145px'
  },
  {
    name: 'Sözleşme Adı',
    id: 'name',
    selector: row => row['name'],
    sortable: false,
    grow: 2
  }
];

// Customer Pharmacies
export const customerPharmaciesList = [
  {
    name: 'Eczane Adı',
    id: 'pharmacy_name',
    selector: row => row['pharmacy_name'],
    sortable: false
  }
];

// Customer Orders
export const customerOrdersList = [
  {
    name: 'Sipariş Tarihi',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    width: '140px'
  },
  {
    name: 'Sipariş No',
    id: 'order_no',
    selector: row => row['order_no'],
    sortable: false,
    maxWidth: '125px'
  },
  {
    name: 'Eczane Adı',
    id: 'pharmacy_name',
    selector: row => row['pharmacy_name'],
    sortable: false,
    grow: 2
  },
  {
    name: 'Teslimat Yöntemi',
    id: 'delivery_type',
    selector: row => row['delivery_type'],
    sortable: false,
    minWidth: '165px'
  },
  {
    name: 'Sipariş Durumu',
    id: 'status',
    selector: row => row['status'],
    sortable: false,
    minWidth: '160px'
  }
];

// Customer Contact Us List
export const contactUsFormList = [
  {
    name: 'Ad Soyad',
    id: 'name',
    selector: row => row['name'],
    sortable: true,
    grow: 2,
    minWidth: '170px'
  },
  {
    name: 'Konu',
    id: 'subject',
    selector: row => row['subject'],
    sortable: false
  },
  {
    name: 'Tarih - Saat',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    maxWidth: '150px'
  },
  {
    name: 'Detay',
    id: 'detail_btn',
    selector: row => row['detail_btn'],
    sortable: false,
    center: true,
    ignoreRowClick: true
  }
];

// Order management - Orders List
export const orderList = [
  {
    name: 'Ad Soyad',
    id: 'name',
    selector: row => row['name'],
    sortable: true,
    minWidth: '150px',
    grow: 2
  },
  {
    name: 'Telefon',
    id: 'telephone',
    selector: row => row['telephone'],
    sortable: false,
    minWidth: '165px',
    maxWidth: '170px'
  },

  {
    name: 'Sipariş Tarihi',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    width: '140px',
    maxWidth: '150px'
  },
  {
    name: 'Sipariş No',
    id: 'order_no',
    selector: row => row['order_no'],
    sortable: false,
    maxWidth: '130px'
  },
  {
    name: 'Eczane Adı',
    id: 'pharmacy_name',
    selector: row => row['pharmacy_name'],
    sortable: false,
    minWidth: '175px',
    grow: 3
  },
  {
    name: 'Teslimat Yöntemi',
    id: 'delivery_type',
    selector: row => row['delivery_type'],
    sortable: false,
    minWidth: '165px',
    maxWidth: '170px'
  },
  {
    name: 'Sipariş Durumu',
    id: 'status',
    selector: row => row['status'],
    sortable: false,
    minWidth: '160px',
    maxWidth: '165px'
  }
];

// campaign list
export const campaignList = [
  {
    name: 'Başlangıç Tarihi',
    id: 'start_date',
    selector: row => row['start_date'],
    sortable: true,
    maxWidth: '150px'
  },
  {
    name: 'Bitiş Tarihi',
    id: 'end_date',
    selector: row => row['end_date'],
    sortable: true,
    maxWidth: '140px'
  },
  {
    name: 'Kampanya Adı',
    id: 'name',
    selector: row => row['name'],
    sortable: true,
    grow: 3
  },
  {
    name: 'Durum',
    id: 'update_status',
    selector: row => row['update_status'],
    sortable: false,
    maxWidth: '160px',
    center: true,
    ignoreRowClick: true
  }
];

// Campaigns Pharmacies list
export const campaignPharmaciesList = [
  {
    name: 'Eczane Adı',
    id: 'pharmacy_name',
    selector: row => row['pharmacy_name'],
    sortable: true,
    minWidth: '175px',
    grow: 3
  },
  {
    name: 'İl',
    id: 'city_id',
    selector: row => row['city_id'],
    sortable: true,
    minWidth: '175px',
    maxWidth: '190px'
  },
  {
    name: 'İlçe',
    id: 'district_id',
    selector: row => row['district_id'],
    sortable: true,
    minWidth: '175px',
    maxWidth: '185px'
  },

  {
    name: 'Katılım Tarihi',
    id: 'created_at',
    selector: row => row['created_at'],
    sortable: true,
    width: '150px',
    maxWidth: '160px'
  },
  {
    name: 'Sil',
    id: 'delete_btn',
    selector: row => row['delete_btn'],
    width: '100px',
    sortable: false,
    center: true,
    ignoreRowClick: true
  }
];

export const notCampaignPharmacyList = [
  {
    name: 'Eczane Adı',
    id: 'name',
    selector: row => row['name'],
    sortable: false,
    minWidth: '275px',
    grow: 2
  },
  {
    name: 'Eczane Kodu',
    id: 'code',
    selector: row => row['code'],
    sortable: false
  }
];

// Parameter Management

//  product list
export const productsList = [
  {
    name: 'Ürün/İlaç Adı',
    id: 'name',
    selector: row => row['name'],
    sortable: true,
    minWidth: '250px',
    grow: 3
  },
  {
    name: 'Barkod',
    id: 'barcode',
    selector: row => row['barcode'],
    sortable: true,
    maxWidth: '150px'
  },
  {
    name: 'ATC Kodu',
    id: 'atc_code',
    selector: row => row['atc_code'],
    sortable: true,
    maxWidth: '135px'
  },
  {
    name: 'ATC Adı',
    id: 'atc_name',
    selector: row => row['atc_name'],
    sortable: true,
    maxWidth: '165px'
  },
  {
    name: 'Durum',
    id: 'update_status',
    selector: row => row['update_status'],
    sortable: false,
    maxWidth: '150px',
    center: true,
    ignoreRowClick: true
  }
];
